import type { SVGProps } from 'react';
const SvgDynamicForm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#dynamic_form_svg__a)">
      <path
        fill="currentColor"
        d="M17 20v-9h-2V4h7l-2 5h2l-5 11Zm-2-7v7H4c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h11Zm-8.75 2.75h-1.5v1.5h1.5v-1.5ZM13 4v7H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h9ZM6.25 6.75h-1.5v1.5h1.5v-1.5Z"
      />
    </g>
    <defs>
      <clipPath id="dynamic_form_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDynamicForm;
